import axios from "axios";


const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});


api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pipeforge_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export const downloadFile = async (url, params = {}) => {
  const response = await api.get(url, { params, responseType: "blob" });
  const disposition = response.headers["content-disposition"] || "";
  const matchedName = disposition.match(/filename="?([^\"]+)"?/i)?.[1] || "tarka-hr-report.xlsx";
  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", matchedName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};


export default api;